var map = {
	"./beersheva.jpg": 5724,
	"./bengurion.png": 4056,
	"./eilat.jpg": 4417,
	"./haifa.png": 3981,
	"./jerusalem.jpg": 3509,
	"./raanana.jpg": 2880,
	"./ramon.jpg": 3423,
	"./telaviv.jpg": 9127,
	"./tiberias.jpg": 9111
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6989;